import { GridWidget } from '@/components/GridWidget.tsx';

import { Generator } from './generators/Generator.tsx';
import { useGetGenerators } from './generators/useGetGenerators.ts';

export const Generators = () => {
  const { generators, isLoading } = useGetGenerators();

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 2 }, (_, index) => (
          <GridWidget headerTitle={`Generator ${index + 1}`} key={`Generator_${index}`} isLoading />
        ))}
      </>
    );
  }

  return (
    generators && (
      <>
        {Object.values(generators).map((generator, index) => (
          <Generator
            key={`${index}_${generator.inventoryId}_${generator.index}`}
            generator={generator}
          />
        ))}
      </>
    )
  );
};
